export default "__VITE_ASSET__CFnqRcor__"